import React, { useMemo } from 'react'

import type { KeyIconsType } from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import { Typography } from 'components/uiKit/Typography'
import { t } from 'services/Translation'

import ColorCircle from '../ColorCircle'
import type { IColorOption } from '../ColorPicker.types'
import * as s from './ColorRoot.module.scss'

interface IColorRootProps {
  value?: string | null
  color: string
  icon?: KeyIconsType
  size?: KitSize
  name: string
  labeled?: boolean
  option?: IColorOption
  onBlur?: () => void
  onFocus?: () => void
  forceLabel?: string
  active?: boolean
}

const ColorRoot = React.forwardRef<HTMLDivElement, IColorRootProps>(
  (
    { value, color, icon, size, name, labeled, option, onBlur, onFocus, forceLabel, active },
    ref,
  ) => {
    const label = useMemo(() => {
      if (!labeled || value === null) {
        return null
      }

      if (forceLabel) {
        return forceLabel
      }
      if (value === 'transparent') {
        return t('uiKit.button.transparent')
      }

      return option?.rootLabel || color.slice(0, 7)
    }, [forceLabel, color, labeled, option?.rootLabel, value])

    return (
      <div className={s.root} ref={ref}>
        {label && (
          <span className={s.label}>
            <Typography rows={1} size={KitSize.XS} wordBreak='break-all'>
              {label}
            </Typography>
          </span>
        )}
        <ColorCircle
          active={active}
          color={color}
          empty={value === null}
          icon={icon}
          name={name}
          onBlur={onBlur}
          onFocus={onFocus}
          size={size}
          transparent={value === 'transparent'}
        />
      </div>
    )
  },
)

ColorRoot.displayName = 'ColorRoot'

export default ColorRoot
